module.exports = __webpack_public_path__ + "img/nav_icon_account.2ade4ea7.svg";